function equal<T>(a: T[], b: T[]): boolean {
	if (a.length !== b.length) return false;
	return a.every((v, i) => v === b[i]);
}

function deduplicate<T>(arr: T[]): T[] {
	const seen = new Map();
	return arr.filter((item) => {
		if (seen.has(item)) return false;
		seen.set(item, true);
		return true;
	});
}

export const ArrayUtils = {
	equal,
	deduplicate,
};
